import { render } from "./addDocumentTemplate.vue?vue&type=template&id=363fb0a0"
import script from "./addDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./addDocumentTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__